module.exports = __webpack_public_path__ + "img/13.936b6a2a.png";